<template>
  <div>
    <template v-if="loading_step === false">
      <div class="row">
        <ul class="col s12 no-padding collapsible docs">
          <li class="col s12 no-padding">
            <div class="collapsible-header">
              Identidade
              <i v-if="docs_statuses[1] === true" class="material-icons">check</i>
              <template v-else>
                <i v-if="meta.censo_domain[selectedMunicipio].formulario_documentos_obrigatorios.documentos.includes(1)" class="material-icons red-text">error</i>
              </template>
            </div>
            <div class="col s12 no-padding collapsible-body">
              <identidade ref="1" @statusChange="handleStatusChange" @docSaved="handleDocSaved" v-bind:pf_id="pf_id" v-bind:doc="documentos_data.rg" />
            </div>
          </li>

          <li class="col s12 no-padding">
            <div class="collapsible-header">
              PIS/PASEP/NIT
              <i v-if="docs_statuses[2] === true" class="material-icons">check</i>
              <template v-else>
                <i v-if="meta.censo_domain[selectedMunicipio].formulario_documentos_obrigatorios.documentos.includes(2)" class="material-icons red-text">error</i>
              </template>
            </div>
            <div class="col s12 no-padding collapsible-body">
              <ppn ref="2" @statusChange="handleStatusChange" @docSaved="handleDocSaved" v-bind:pf_id="pf_id" v-bind:doc="documentos_data.ppn" />
            </div>
          </li>

          <li class="col s12 no-padding">
            <div class="collapsible-header">
              CNH
              <i v-if="docs_statuses[3] === true" class="material-icons">check</i>
              <template v-else>
                <i v-if="meta.censo_domain[selectedMunicipio].formulario_documentos_obrigatorios.documentos.includes(3)" class="material-icons red-text">error</i>
              </template>
            </div>
            <div class="col s12 no-padding collapsible-body">
              <cnh ref="3" @statusChange="handleStatusChange" @docSaved="handleDocSaved" v-bind:pf_id="pf_id" v-bind:doc="documentos_data.cnh" />
            </div>
          </li>
          <li class="col s12 no-padding">
            <div class="collapsible-header">
              Título de eleitor
              <i v-if="docs_statuses[4] === true" class="material-icons">check</i>
              <template v-else>
                <i v-if="meta.censo_domain[selectedMunicipio].formulario_documentos_obrigatorios.documentos.includes(4) && perfil_data.idade >= 18" class="material-icons red-text">error</i>
              </template>
            </div>
            <div class="col s12 no-padding collapsible-body">
              <titulo ref="4" @statusChange="handleStatusChange" @docSaved="handleDocSaved" v-bind:pf_id="pf_id" v-bind:doc="documentos_data.tit_ele" />
            </div>
          </li>
          <li class="col s12 no-padding">
            <div class="collapsible-header">
              Certidão de nascimento
              <i v-if="docs_statuses[5] === true" class="material-icons">check</i>
              <template v-else>
                <i v-if="meta.censo_domain[selectedMunicipio].formulario_documentos_obrigatorios.documentos.includes(5)" class="material-icons red-text">error</i>
              </template>
            </div>
            <div class="col s12 no-padding collapsible-body">
              <certidao ref="5" @statusChange="handleStatusChange" @docSaved="handleDocSaved" v-bind:pf_id="pf_id" v-bind:doc="(documentos_data.cert ? documentos_data.cert : {})" />
            </div>
          </li>
          <li class="col s12 no-padding">
            <div class="collapsible-header">
              Conselho de classe
              <i v-if="docs_statuses[6] === true" class="material-icons">check</i>
              <template v-else>
                <i v-if="meta.censo_domain[selectedMunicipio].formulario_documentos_obrigatorios.documentos.includes(6)" class="material-icons red-text">error</i>
              </template>
            </div>
            <div class="col s12 no-padding collapsible-body">
              <conselho ref="6" @statusChange="handleStatusChange" @docSaved="handleDocSaved" v-bind:pf_id="pf_id" v-bind:doc="(documentos_data.cart_class ? documentos_data.cart_class : {})" />
            </div>
          </li>
          <li class="col s12 no-padding">
            <div class="collapsible-header">
              Reservista
              <i v-if="docs_statuses[7] === true" class="material-icons">check</i>
              <template v-else>
                <i v-if="meta.censo_domain[selectedMunicipio].formulario_documentos_obrigatorios.documentos.includes(7) && perfil_data.sexo == 'M' && perfil_data.idade >= 18" class="material-icons red-text">error</i>
              </template>
            </div>
            <div class="col s12 no-padding collapsible-body">
              <reservista ref="7" @statusChange="handleStatusChange" @docSaved="handleDocSaved" v-bind:pf_id="pf_id" v-bind:doc="(documentos_data.reservista ? documentos_data.reservista : {})" />
            </div>
          </li>
          <li class="col s12 no-padding">
            <div class="collapsible-header">
              Formação acadêmica
              <i v-if="docs_statuses[8] === true" class="material-icons">check</i>
              <template v-else>
                <i v-if="meta.censo_domain[selectedMunicipio].formulario_documentos_obrigatorios.documentos.includes(8)" class="material-icons red-text">error</i>
              </template>
            </div>
            <div class="col s12 no-padding collapsible-body">
              <graduacoes ref="8" @statusChange="handleStatusChange" @docSaved="handleDocSaved" v-bind:pf_id="pf_id" v-bind:doc="(documentos_data.cursos ? documentos_data.cursos : {})" />
            </div>
          </li>
        </ul>
      </div>
      <div class="step-actions">
        <button class="waves-effect waves-dark btn-flat previous-step">Anterior</button>
        <button v-bind:disabled="step_completed === false" type="button" @click="submitStep" class="waves-effect waves-dark btn">Próximo</button>
      </div>
    </template>
    <template v-else>
      <loading />
    </template>
  </div>

</template>
<script>
import Loading from '@/components/Loading.vue'
import Identidade from '@/components/steps/documentos/Identidade.vue'
import Pispasepnit from '@/components/steps/documentos/Pispasepnit.vue'
import CNH from '@/components/steps/documentos/CNH.vue'
import TituloEleitor from '@/components/steps/documentos/TituloEleitor.vue'
import CertNascCas from '@/components/steps/documentos/CertNascCas.vue'
import ConselhoClasse from '@/components/steps/documentos/ConselhoClasse.vue'
import Reservista from '@/components/steps/documentos/Reservista.vue'
import Graduacoes from '@/components/steps/documentos/Graduacoes.vue'

export default {
name: 'Documentos',
components: {
  loading: Loading,
  identidade: Identidade,
  ppn: Pispasepnit,
  cnh: CNH,
  titulo: TituloEleitor,
  certidao: CertNascCas,
  conselho: ConselhoClasse,
  reservista: Reservista,
  graduacoes: Graduacoes,
},
props: {
  documentos_data: Object,
  perfil_data: Object
},
data (){
  return {
    meta: this.$store.state.meta.data,
    pf_id: this.$store.state.user.pfId,
    loading_step: false,
    changed: false,
    step_completed: false,
    form_grad: false,
    addNewGrad: false,
    docs: {
    },
    error: null,
    collapsible: null,
    docs_statuses: {
      1: false,
      2: false,
      3: false,
      4: false,
      5: false,
      6: false,
      7: false,
      8: false
    },
    selectedMunicipio: localStorage.selectedMunicipio
  }
},
computed: {
  cursos: function () {
    return ('8' in this.$refs ? this.$refs[8].cursos : 0)
  }
},
methods: {
  handleStatusChange(doc_status){
    this.docs_statuses[doc_status['doc']] = doc_status['status']
    this.step_completed = this.verificaStatusPasso()
  },
  verificaStatusPasso(){
    const result = []
    this.meta.censo_domain[this.selectedMunicipio].formulario_documentos_obrigatorios.documentos.map((docs, i) => {

      // Título de Eleitor
      if(i == 3) {
        if(this.perfil_data.idade >= 18) {
          result.push(this.docs_statuses[docs] === true)
        }
      } else if(i == 6) {
        if(this.perfil_data.sexo == 'M') {
          result.push(this.docs_statuses[docs] === true)
        }
      } else {
        if(this.docs_statuses[docs] === true) {
          result.push(true)
        } else {
          result.push(false)
        }
      }
    })
    if(result.includes(false)) {
      return false
    } else {
      return true
    }
  },
  handleDocSaved(doc){
    if(doc < 7){
      this.collapsible.close(doc)
      this.collapsible.open(doc +1)
    } else {
      this.collapsible.close(doc)
    }
  },
  submitStep() {
    this.$emit('moveNextStep', {step: 1, completed: this.step_completed})
  },
  initStep(){
    setTimeout(() => {
      M.updateTextFields()
      M.FormSelect.init(document.querySelectorAll('select'))
      M.Tooltip.init(document.querySelectorAll('.tooltipped'))
      this.changed = false
      M.Collapsible.init(document.querySelectorAll('.collapsible.docs'))
      this.collapsible = M.Collapsible.getInstance(document.querySelectorAll('.collapsible.docs')[0])
    }, 200)
  }
},
watch: {
  docs: {
    handler: function(updated_perfil, old_perfil){
      this.changed = true
    },
    deep: true
  }
},
mounted(){
  this.initStep()
}
}
</script>



// WEBPACK FOOTER //
// src/components/steps/Documentos.vue